<div class="content-about-container">
  <div class="ms-3 mt-3">
    <h1>
      About the state house
    </h1>
  </div>
  <div class="aboutDatesList">
    <div (click)="showDate(0)" class="aboutWrapper">
      <div class="aboutDate aboutDate0 active"></div>
      <div class="aboutText">1793</div>
    </div>
    <div (click)="showDate(1)" class="aboutWrapper">
      <div class="aboutDate aboutDate1"></div>
      <div class="aboutText">1825</div>
    </div>
    <div (click)="showDate(2)" class="aboutWrapper">
      <div class="aboutDate aboutDate2"></div>
      <div class="aboutText">1870</div>
    </div>
    <div (click)="showDate(3)" class="aboutWrapper">
      <div class="aboutDate aboutDate3"></div>
      <div class="aboutText">1904</div>
    </div>
    <div (click)="showDate(4)" class="aboutWrapper">
      <div class="aboutDate aboutDate4"></div>
      <div class="aboutText">1920</div>
    </div>
    <div (click)="showDate(5)" class="aboutWrapper">
      <div class="aboutDate aboutDate5"></div>
      <div class="aboutText">Today</div>
    </div>
  </div>
  <div class="dateContent">
    <div class="date0">
      <div class="dateImage aboutDate0 dateLargeImage"></div>
      <div class="dateInfo dateInfo0">
        <div class="dateInfoYear">1793</div>
        <div class="dateInfoSubHeader">The Old State House</div>
        <div class="dateInfoText">
          The Old State House, located at the intersection of Washington and State Streets,
          was constructed in 1713, replacing the older Towne House, and served as the seat of colonial
          government until the construction of the new state house in 1798.  A merchants exchange and
          other businesses occupied the basement and ground floors, while the Council Chamber
          (depicted in the James Otis mural in Doric Hall) and Representatives’ Hall, the legislator’s
          assembly room, were located on the second. The Declaration of Independence was first read to
          citizens of Boston from the balcony on July 18, 1776.
        </div>
        <div class="dateInfoCreds">Old State House, State Street. Collection Boston Pictorial Archives, Digital Commonwealth.</div>
      </div>
    </div>
    <div class="date1 hideDate">
      <div class="dateImage aboutDate1 dateLargeImage"></div>
      <div class="dateInfo dateInfo1">
        <div class="dateInfoYear">1825</div>
        <div class="dateInfoSubHeader">The New Bulfinch State House</div>
        <div class="dateInfoText">
          The new State House was constructed on land previously owned by John Hancock
          whose house can be seen to the left of the capitol.  Designed by Charles Bulfinch, the new State House
          houses the Massachusetts General Court and Offices of the Governor.  Located on the summit of Beacon Hill,
          the State House was the tallest structure by far, and could be seen from nearly every vantage point –
          even by ships at sea. It overlooks Boston Common, founded in 1634, the oldest public park in America.
        </div>
        <div class="dateInfoCreds">View of the new State House by James Kidder, engraved by Abel Bowen, c. 1825. Collection Boston Public Library.</div>
      </div>
    </div>
    <div class="date2 hideDate">
      <div class="dateImage aboutDate2 dateLargeImage"></div>
      <div class="dateInfo dateInfo2">
        <div class="dateInfoYear">1870</div>
        <div class="dateInfoSubHeader">The Bryant Addition</div>
        <div class="dateInfoText">
          The original red brick façade was painted white around 1825, and then yellow, c. 1855.
          At the rear of the building can be seen the first of several additions, designed by Gridley Bryant to provide additional
          office space and a new state library. Fountains installed on the front grounds in 1849 were removed in 1919.
        </div>
        <div class="dateInfoCreds">Massachusetts State House. Collection Boston Pictorial Archives, Digital Commonwealth.</div>
      </div>
    </div>
    <div class="date3 hideDate">
      <div class="dateImage aboutDate3 dateLargeImage"></div>
      <div class="dateInfo dateInfo3">
        <div class="dateInfoYear">1904</div>
        <div class="dateInfoSubHeader">The Brigham Extension</div>
        <div class="dateInfoText">
          In order to accommodate the rapidly expanding state government, the Bryant extension was taken down and the cornerstone laid
          in 1888 for a large addition that extended from the back of the original Bulfinch structure to Derne Street.
          It spanned Mount Vernon Street which could still be accessed through the arched opening seen off the wide boulevard that
          swept along the east side of the building.  Designed by Charles Brigham, this addition provided a new House Chamber,
          offices for legislators and committee, as well as large, richly decorated ceremonial halls.
        </div>
        <div class="dateInfoCreds">
          State House, c. 1904, showing the Brigham extension and the General Joseph Hooker statue,
          installed 1903.  Collection Library of Congress.
        </div>
      </div>
    </div>
    <div class="date4 hideDate">
      <div class="dateImage aboutDate4 dateLargeImage"></div>
      <div class="dateInfo dateInfo4">
        <div class="dateInfoYear">1920</div>
        <div class="dateInfoSubHeader">East & West Wings</div>
        <div class="dateInfoText">
          In 1917, the east and west wings were added to the sides of the Bulfinch capitol to provide even more office space.
          The large park that once bordered the Brigham extension was shortened, and a traffic circle constructed around the
          Beacon Hill Monument (erected 1898) to accommodate the now ubiquitous automobile.  By the 1950s, the two memorials
          that once graced the park were removed and the entire area turned into a parking lot. The park was restored in 1990
          and is now home to the Massachusetts Fallen Firefighters and Law Enforcement Memorials.
        </div>
        <div class="dateInfoCreds">
          Park along Bowdoin Street enclosed by the Brigham extension and the East wing, c. 1920.
          Collection Boston Pictorial Archives, Digital Commonwealth.
        </div>
      </div>
    </div>
    <div class="date5 hideDate">
      <div class="dateImage aboutDate5 dateLargeImage"></div>
      <div class="dateInfo dateInfo5">
        <div class="dateInfoYear">Today</div>
        <div class="dateInfoSubHeader">Today's State House</div>
        <div class="dateInfoText">
          Since 1917, the Massachusetts State House exterior structure has seen little change. Inside the State House,
          great lengths have been taken to retain the original beauty of the structure, but at the same time,
          bringing the State House into the information technology era. Today, the State House offers public Wi-Fi,
          interactive information screens, multi-media rooms, state of the art audio & video recording studios, and,
          in the near future, a smart phone application to enhance the visitor experience. For more information on the State House,
          please visit the State House Tours and Information Desk located in Doric Hall on the Second Floor.
        </div>
        <div class="dateInfoCreds"></div>
      </div>
    </div>
  </div>
</div>
